// The same job done twice: some automations on Communications and some
// journeys send the same kind of message (rebooking, birthdays, thank-yous
// after a visit, missed appointments). With both on, clients get two. This
// works out which is which so each side can say so and offer to switch the
// other off. Nothing is merged: the features stay apart.
import { marketingAction } from '../../_actions/marketing.actions';

export const JOB_WORDS = {
  rebook: 'a reminder to rebook',
  birthday: 'a birthday message',
  thanks: 'a thank-you after a visit',
  noshow: 'a message after a missed appointment',
};

// What a journey does, from its trigger and its first steps
export const journeyJob = (j) => {
  const t = j && j.trigger && j.trigger.type;
  const steps = (j && j.steps) || [];
  const firstWait = (steps.find((s) => s.type === 'wait') || {}).days || 0;
  const filtered = steps.some((s) => s.type === 'filter');
  if (t === 'birthday') return 'birthday';
  if (t === 'no-show') return 'noshow';
  if (t === 'new-client') return 'thanks';
  if (t === 'appointment-completed') return filtered || firstWait >= 7 ? 'rebook' : 'thanks';
  return null;
};

const isOn = (x) => !!x && (x.statusSMSreminder === 1 || x.statusEmailReminder === 1);

// The Communications automations that are on, each with its job and how to
// switch it off. `settings` is the raw marketing settings result.
// bookingUpdate is in a fixed order: new booking, updated, no-show,
// cancelled, thank you after visiting, thank you for tipping.
// salesUpdate: reminder to rebook (type 1), happy birthday.
export const commsJobs = (settings) => {
  const s = settings || {};
  const out = [];
  (s.salesUpdate || []).forEach((x, i) => {
    const job = x.type === 1 || (x.type == null && i === 0) ? 'rebook' : 'birthday';
    if (isOn(x)) out.push({ job, list: 'salesUpdate', id: x._id, label: job === 'rebook' ? 'Reminder to rebook' : 'Happy birthday' });
  });
  (s.bookingUpdate || []).forEach((x, i) => {
    if (i === 2 && isOn(x)) out.push({ job: 'noshow', list: 'bookingUpdate', id: x._id, label: 'No-show' });
    if (i === 4 && isOn(x)) out.push({ job: 'thanks', list: 'bookingUpdate', id: x._id, label: 'Thank you after visiting' });
  });
  (s.customUpdate || []).forEach((x) => {
    const job = x.triggerType === 2 ? 'rebook' : x.triggerType === 3 ? 'birthday' : null;
    if (job && isOn(x)) out.push({ job, list: 'customUpdate', id: x._id, label: x.title || 'A custom automation' });
  });
  return out;
};

export const loadCommsSettings = (dispatch) => dispatch(marketingAction.getSettings())
  .then((res) => (res && res.data && res.data.statusCode === 1 && res.data.responseData && res.data.responseData.result) || null)
  .catch(() => null);

// Switch Communications automations off, by what commsJobs found
export const switchOffComms = async (dispatch, settings, found) => {
  const next = { ...settings };
  found.forEach((f) => {
    next[f.list] = (next[f.list] || []).map((x) => (x._id === f.id ? { ...x, statusSMSreminder: 0, statusEmailReminder: 0 } : x));
  });
  const res = await dispatch(marketingAction.updateSetting({ ...next, type: 1 }));
  if (!res || !res.data || res.data.statusCode !== 1) throw new Error('Communications didn’t save.');
  return next;
};

// Which Communications job a switch on that page does
export const commsJobOf = (type, item, settings) => {
  const s = settings || {};
  if (type === 'sales') {
    const i = (s.salesUpdate || []).findIndex((x) => x._id === item._id);
    return item.type === 1 || (item.type == null && i === 0) ? 'rebook' : 'birthday';
  }
  if (type === 'booking') {
    const i = (s.bookingUpdate || []).findIndex((x) => x._id === item._id);
    return i === 2 ? 'noshow' : i === 4 ? 'thanks' : null;
  }
  if (type === 'custom') return item.triggerType === 2 ? 'rebook' : item.triggerType === 3 ? 'birthday' : null;
  return null;
};
